<div class="med-medication-item">
  <a routerLink="/medication/{{medicationId}}/detail"
     [attr.aria-label]="'SI_DETAIL_MEDICATION' | translate">
    <div class="med-medication-item_container pointer pasi-hover_scale" [class.med-medication-item_container_secondary]="isPast">
      <div class="d-flex">
        <div class="text-wrap flex-grow-1">
          <div class="med-medication-item_container_title">{{title}}</div>
          <div class="med-medication-item_container_darkgrey">{{activeIngredient}}</div>
        </div>
      </div>
      <div class="pasi-line-lightgrey my-1"></div>
      <div class="d-flex w-100">
        <div class="med-medication-item_container_box">
          <div class="med-medication-item_container_state text-right" [class.med-medication-item_container_danger]="!isCurrent">
            {{stateText | translate}}
          </div>
          <div class="med-medication-item_container_title text-right">
            {{initDate | amDateFormat: 'DD MMM' | uppercase}}
          </div>
          <div class="med-medication-item_container_year text-right">
            {{initDate | amDateFormat: 'YYYY'}}
          </div>
        </div>
        <div class="pasi-v-line-small-lightgrey"></div>
        <div class="d-flex flex-column justify-content-center text-truncate">
          <div class="d-flex align-items-center med-medication-item_container_dosage">
            <i class="icosun-pill mr-1"></i>
            <span class="text-truncate">{{quantity}}{{unit}}&nbsp;-&nbsp;{{periodicityType | frequencyString: periodicity}}&nbsp;-&nbsp;{{dosageSchedule}}</span>
          </div>
          <div *ngIf="observations" class="d-flex align-items-center med-medication-item_container_darkgrey">
            <i class="icosun-message-reply-text mr-1"></i>
            <span class="text-truncate">{{observations}}</span>
          </div>
          <div *ngIf="periodicityType?.code !== diaryEventPeriodicityTypeCodes.NO_REPEAT"
                class="d-flex align-items-center med-medication-item_container_darkgrey">
            <ng-container *ngIf="periodicity.finalDate; else doesNotEnd">
              <i class="icosun-calendar mr-1"></i>
              <span [class.bold]="isCurrent">{{'SI_UNTIL' | translate}}&nbsp;{{periodicity?.finalDate | amDateFormat: 'L'}}</span>
            </ng-container>
            <ng-template #doesNotEnd>
              <i class="icosun-calendar_change mr-1"></i>
              <span class="bold">{{'SI_DOES_NOT_END' | translate}}</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>
